import { autoinject } from 'aurelia-framework';
import {DialogController} from "aurelia-dialog";
import 'jquery';
import 'notify';

@autoinject
export class SimpleDialog {
    constructor(protected controller: DialogController) {
    }

    params: object;

    activate(params) {
        //convert \n to <br/>

        //params.message = params.message.replace("\n", "<br>");
        this.params = params;
    }

}